import { RequestPaymentModel } from '@bootpay/client-js/models/bootpay-interface';
import { GiftOrder, GiftOrderItem } from '@shared/api/giftOrder/giftOrder.interface';
import { User } from '@shared/api/user/user.interface';
import { dateFormatBootPay } from '@shared/utils/bootpayUtil';

interface IParams {
  giftOrder: GiftOrder;
  userProfile: User<string>;
}

// giftItem에서 ID 추출 헬퍼 함수
const getGiftItemId = (giftItem: GiftOrderItem['giftItem']): string => {
  if (typeof giftItem === 'string') {
    return giftItem;
  }
  if (giftItem && typeof giftItem === 'object' && '_id' in giftItem) {
    return (giftItem as { _id: string })._id;
  }
  return '';
};

/**
 * Gift Order용 Bootpay 결제 요청 DTO 생성 (다중 상품 지원)
 * - REACT_APP_BOOTPAY_GIFT_APPLICATION_ID 사용
 */
export const getGiftBootpayRequestPaymentDto = ({
  giftOrder,
  userProfile,
}: IParams): RequestPaymentModel => {
  // 주문명 생성
  const firstItem = giftOrder.orderDetails[0];
  const firstItemName = firstItem?.giftItemEmbed.name || '답례품';
  const firstItemQty = firstItem?.quantity || 1;

  // 단일 상품: "상품명 x 10개", 다중 상품: "상품명 외 N건"
  const orderName =
    giftOrder.orderDetails.length > 1
      ? `${firstItemName} 외 ${giftOrder.orderDetails.length - 1}건`
      : `${firstItemName} x ${firstItemQty}개`;

  // Bootpay items 배열 생성 (각 상품에 수량 표시)
  const items = giftOrder.orderDetails.map((detail) => ({
    id: getGiftItemId(detail.giftItem),
    name: `${detail.giftItemEmbed.name} x ${detail.quantity}개`,
    price: detail.giftItemEmbed.priceRetail,
    qty: detail.quantity,
  }));

  return {
    price: giftOrder.paymentDetail.paymentByCash, // 총 결제할 금액
    application_id: process.env.REACT_APP_BOOTPAY_GIFT_APPLICATION_ID, // Gift 전용 Application ID
    order_name: orderName,
    pg: '나이스페이',
    items,
    user: {
      username: userProfile.info.name ?? '',
      email: '',
      phone: userProfile.info.phoneNumber ?? '',
      addr: '',
    },
    tax_free:
      giftOrder.paymentDetail.paymentByCash -
      (giftOrder.paymentDetail.taxableAmount ?? 0),
    order_id: giftOrder._id,
    extra: {
      open_type: window.opener ? 'popup' : 'iframe',
      browser_open_type: [
        {
          browser: 'instagram',
          open_type: 'popup',
        },
        {
          browser: 'facebook',
          open_type: 'popup',
        },
        {
          browser: 'kakaotalk',
          open_type: 'popup',
        },
        {
          browser: 'naver',
          open_type: 'popup',
        },
        {
          browser: 'mobile_safari',
          open_type: 'popup',
        },
        {
          browser: 'mobile_chrome',
          open_type: 'iframe',
        },
      ],
      display_success_result: true,
      display_error_result: true,
      deposit_expiration: dateFormatBootPay(new Date(Date.now() + 1 * 24 * 3600 * 1000)),
      card_quota: '0', // 일시불
    },
  };
};
